<template>
	<div id="threeClass_index_edu">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<div v-on:click="screen()"><dv-decoration-9 :color="['#34e8e2', '#289ba5']" class="full_screen">{{ screenName }}</dv-decoration-9></div>
				<div class="d-flex jc-center title_bg"></div>
				<!-- 数据开始 -->
				<div class="body_box">
					<!-- 学校开始 -->
					<div class="school_block">
						<div class="campus_safetit float-l"><img src="../../assets/img/school_icon.png"><b>选择学校</b></div>
						<ul class="float-l">
							<li :class="activeClass1 == index ? 'on' : ''" v-for="(org, index) in orgList" :key="index" @click="changeOrg(index, org.orgId)">{{ org.orgName }}</li>
						</ul>
						<div class="more_btn float-r" v-if="orgNum > 5" @click="showTable()"><dv-border-box-8>查看更多&#10148;</dv-border-box-8></div>
					</div>
					<!-- 学校结束 -->
					<div class="threec_left">
						<div class="threec_tab">
							<ul>
								<li :class="activeClass2 == index ? 'on' : ''" v-for="(room, index) in roomList" :key="index" @click="changeTab(room.playAddress, index, room.drsList)">{{ room.recordRoomName }}</li>
							</ul>
						</div>
						<div class="threec_video">
							<dv-border-box-5 :color="['#12eedc', '#07b9bc']">
								<iframe :src="playUrl" frameborder="0" class="iframeContent"></iframe>
							</dv-border-box-5>
						</div>
					</div>
					<div class="threec_right">
						<div class="threer_tit">
							<dv-decoration-8 :color="['#12eedc', '#037070']" style="width:100px;height:30px;" />
							<div class="threec_link">观看端画面</div>
							<dv-decoration-8 :reverse="true" :color="['#12eedc', '#024c4c']" style="width:100px;height:30px;" />
						</div>
						<ul>
							<li v-for="(school, index) in schoolList" :key="index" @click="openView(school.pubAddress, school.pubPort)">
								<dv-border-box-10 :color="['#0ae7d5', '#00f3ff']">
									<div class="threecblock_tit">{{ school.schoolName }}</div>
									<img class="indexblock_img" src="../../assets/img/video_icon.gif">
									<dv-decoration-5 :color="['#267f7c', '#00f3ff']" style="width:100%;height:40px;" />
								</dv-border-box-10>
							</li>
							<li v-for="num in noneNum" :key="'none_' + num" class="none_video">
								<dv-border-box-10 :color="['#ff4a4d', '#ff2747']">
									<div class="nonevideo_txt">暂无画面</div>
									<img class="indexblock_img" src="../../assets/img/none_video.png">
								</dv-border-box-10>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</dv-full-screen-container>
		<dialog-table v-if="Visible" ref="dialog" @closeTable="closeTable" @changeOrg2="changeOrg2(arguments)"></dialog-table>
	</div>
</template>

<script>
var storage = window.localStorage;
var region = storage.getItem("region");
var orgCode = storage.getItem("orgCode");
import dialogTable from "./dialogTable";
export default {
	components: { dialogTable },
	data() {
		return {
			loading: true,
			fullscreen: false,
			screenName: "全屏",
			orgList: [],
			roomList: [],
			orgNum: 0,
			activeClass1: 0,
			activeClass2: 0,
			playUrl: '',
			schoolList: [],
			noneNum: 0,
			Visible: false
		};
	},
	mounted() {
		this.cancelLoading();
		this.initData();
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		closeTable() {
			this.Visible = false;
		},
		showTable() {
			this.Visible = true;
			this.$nextTick(() => {
				this.$refs.dialog.initData(this.activeClass1);
			})
		},
		initData() {
			let _this = this;
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				_this.screenName = "全屏";
			} else {
				_this.screenName = "返回";
			}
			this.$http.get("/dataView/threeClass/getOrgListByRoom?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					if (result.length > 0) {
						_this.orgNum = result.length;
						_this.orgList = result.slice(0,5);
						this.loadRoom(result[0].orgId);
					}
				}
			});
		},
		loadRoom(orgId) {
			let _this = this;
			this.$http.get("/dataView/threeClass/getPlayInfo?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					if (result.length > 0) {
						_this.roomList = result;
						_this.activeClass2 = 0;
						_this.schoolList = result[0].drsList;
						if (result[0].playAddress.indexOf("http:") != -1) {
							_this.playUrl = result[0].playAddress;
						} else {
							_this.playUrl = "";
						}
						_this.noneNum = (3 - result[0].drsList.length) > 0 ? (3 - result[0].drsList.length) : 0;
					} else {
						_this.noneNum = 3;
					}
				}
			});
		},
		//切换学校
		changeOrg(index, orgId) {
			this.activeClass1 = index;
			this.loadRoom(orgId);
		},
		//切换学校
		changeOrg2(param) {
			this.activeClass1 = param[0];
			this.loadRoom(param[1]);
			this.Visible = false;
		},
		//切换录播教室
		changeTab(playUrl, index, schoolList) {
			let _this = this;
			_this.activeClass2 = index;
			if (playUrl.indexOf("http:") != -1) {
				_this.playUrl = playUrl;
			} else {
				_this.playUrl = "";
			}
			_this.schoolList = schoolList;
			_this.noneNum = (3 - schoolList.length) > 0 ? (3 - schoolList.length) : 0;
		},
		//打开观看端画面
		openView(pubAddress, pubPort) {
			window.open('http://' + pubAddress + ':' + pubPort, '_blank');
		},
		//点击全屏
		screen: function () {
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				let _this = this;
				let element = document.documentElement;
				if (_this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
					_this.screenName = "全屏";
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
					_this.screenName = "取消";
				}
				_this.fullscreen = !_this.fullscreen;
			} else {
				//window.AndroidWebView.finish();
				this.$router.replace('/dataView/appIndex?area=' + region);
			}
		}
	}
};
</script>

<style scoped lang="scss">
#threeClass_index_edu {
	background-color: #181b37;
	width: 100%;
	min-height: 100vh;
	background-image: url("../../assets/img/threec_bg.jpg");
	background-size: 100% 100%;

	.full_screen {
		width: 0.8rem;
		height: 0.8rem;
		position: absolute;
		top: 0.2rem;
		right: 0.3rem;
		font-size: 0.2rem;
		color: #53ffda;
		font-weight: bold;
		-webkit-background-clip: text;
		background-image: linear-gradient(90deg, #4cffd9, #41e0ff);
		-webkit-text-fill-color: transparent;
		cursor: pointer;
	}

	.bg {
		padding: 0.2rem 0.15rem 0 0.15rem;
		background-position: center center;
	}

	.title_bg {
		width: 100%;
		height: 8vh;
		background: url("../../assets/img/threectit_bg.png") center no-repeat;
	}

	.body_box {
		height: 88vh;
		padding: 0 0.2rem 0;
	}

	.threec_left {
		width: 74%;
		height: 85vh;
		float: left;
	}

	.threec_tab {
		display: block;
		overflow: hidden;
	}

	.threec_tab li {
		display: inline-block;
		max-width: 3rem;
		padding: 0.1rem 0.1rem 0.1rem 0.4rem;
		color: #46c6ad;
		font-size: 0.2rem;
		background: url("../../assets/img/threec_tabbg.png") left no-repeat;
		background-size: cover;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.threec_tab li:hover,
	.threec_right ul li:hover {
		cursor: pointer;
	}

	.threec_tab li.on {
		background: url("../../assets/img/threec_tabbgon.png") left no-repeat;
		background-size: cover;
		color: #ffd8d9;
	}

	.threec_video {
		height: 95%;
		margin-top: -0.6%;
	}

	.iframeContent {
		position: relative;
		width: 99%;
		height: 100%;
		padding: 2%;
	}

	//下方区域的布局
	.threec_right {
		width: 25%;
		height: 85vh;
		float: right;
	}

	.threec_right ul::-webkit-scrollbar {
		width: 2px;
	}

	.threec_right ul::-webkit-scrollbar-thumb {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(16, 221, 191, 0.1), rgba(27, 118, 103, 0.1), rgba(20, 195, 221, 0.1));
	}

	.threec_right ul::-webkit-scrollbar-track {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.1), rgba(20, 195, 221, 0));
	}

	.threec_right ul {
		height: 95%;
		box-sizing: border-box;
		overflow-y: auto;
	}

	.threec_right ul li {
		width: 100%;
		height: 25vh;
		margin: 0.35rem 0;
		position: relative;
		text-align: center;
	}

	.threec_right ul li:first-child {
		margin: 0;
	}

	img.indexblock_img {
		width: 100px;
		position: absolute;
		margin-left: -50px;
		top: 20%;
		left: 50%;
	}

	.threer_tit {
		display: flex;
		justify-content: center;
		margin-bottom: 0.06rem;
	}

	.threec_link {
		color: #3dfcff;
		font-size: 0.2rem;
		height: 0.4rem;
		padding: 0 0.2rem;
		line-height: 0.4rem;
	}

	.nonevideo_txt {
		text-align: center;
		color: #9E9E9E;
		font-size: 0.2rem;
		position: absolute;
		width: 200px;
		margin-left: -100px;
		bottom: 20%;
		left: 50%;
	}

	.threecblock_tit {
		font-size: 0.2rem;
		font-weight: bold;
		background: linear-gradient(to right, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.3), rgba(20, 195, 221, 0));
		color: #3dfcff;
		position: absolute;
		width: 90%;
		padding: 0.1rem 0;
		text-align: center;
		bottom: 0;
		left: 5%;
		z-index: 1;
	}

	.none_video {
		background: linear-gradient(to right, rgba(161, 41, 43, 0.4), rgba(143, 16, 19, 0.5));
	}

	//下方区域的布局
	.school_block {
		padding: 0 0 0.6rem 0.2rem;
	}

	.campus_safetit {
		font-size: 0.18rem;
		color: #55ffff;
		margin-bottom: 0.1rem;
		padding-top: 5px;
	}

	.campus_safetit b {
		font-size: 0.25rem;
	}

	.campus_safetit img {
		width: 0.3rem;
		margin-right: 0.05rem;
		vertical-align: middle;
	}

	.school_block ul {
		width: 80%;
		white-space: nowrap;
		display: inline-block;
		margin-left: 0.2rem;
	}

	.school_block ul li {
		width: fit-content;
		max-width: 3.8rem;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		padding: 0.1rem 0.2rem;
		color: #00fff7;
		font-size: 0.2rem;
		border-radius: 2rem;
		margin: 0 0.1rem 0 0;
		box-shadow: 0px 0px 10px #55ffff inset;
		display: inline-block;
	}

	.school_block ul li:hover,
	.school_block ul li.on {
		background-image: linear-gradient(to right, rgba(0, 244, 224, 0.8), rgba(1, 192, 244, 0.7));
		color: #002a2a;
		cursor: pointer;
	}

	.more_btn {
		color: #00ffff;
		font-size: 0.2rem;
		cursor: pointer;
	}

	.more_btn .dv-border-box-8 {
		box-shadow: 0px 0px 10px #00ffe2 inset;
		padding: 0.1rem 0.3rem;
	}
}</style>